const WIZARD_CODES = {
  ONBOARDING: 'onboarding',
  PATIENT_CHECKIN: 'patient_checkin',
  INSTANT_PACKET: 'instant_packet',
  SELF_SCHEDULING: 'self_scheduling',
  PRACTICE_CREATION: 'practice_creation'
};

export const WIZARD_INSTANCE_NOT_FOUND_CODE = 7;

export default WIZARD_CODES;
